import {apiFetch} from 'src/api/fetch'

import {
    type Document,
    DocumentSchema,
    type RenameDocumentRequest,
    RenameDocumentRequestSchema,
} from './schemas'

export async function listCustomerDocuments(customerId: string): Promise<Document[]> {
    const raw = await apiFetch<unknown>(`/customers/${customerId}/documents`)
    return DocumentSchema.array().parse(raw)
}

export async function uploadCustomerDocument(
    customerId: string,
    name: string,
    file: File,
): Promise<Document> {
    const formData = new FormData()
    formData.append('name', name)
    formData.append('file', file)

    const raw = await apiFetch<unknown>(`/customers/${customerId}/documents`, {
        method: 'POST',
        body: formData,
    })
    return DocumentSchema.parse(raw)
}

export async function renameCustomerDocument(
    customerId: string,
    documentId: string,
    input: RenameDocumentRequest,
): Promise<Document> {
    const body = RenameDocumentRequestSchema.parse(input)
    const trimmedBody = {name: body.name.trim()}
    const raw = await apiFetch<unknown>(`/customers/${customerId}/documents/${documentId}`, {
        method: 'PUT',
        body: JSON.stringify(trimmedBody),
    })
    return DocumentSchema.parse(raw)
}

export async function archiveCustomerDocument(
    customerId: string,
    documentId: string,
): Promise<void> {
    await apiFetch<void>(`/customers/${customerId}/documents/${documentId}`, {
        method: 'DELETE',
    })
}

export function getCustomerDocumentDownloadUrl(customerId: string, documentId: string): string {
    return `/api/customers/${customerId}/documents/${documentId}/content`
}
